import React from 'react';
import { TextField, FormLabel, FormHelperText } from '@mui/material';
import { useFormikContext } from 'formik';
import { useFormikHelper } from '@/hooks/useFormikHelper';
import { NOTES_HELP_TEXT } from '@/utils/helperText';

const NotesField = ({ loading }) => {
	const { getFieldProps } = useFormikContext();
	const { getError, getErrorMessage } = useFormikHelper();

	return (
		<>
			<FormLabel>{'Notes'}</FormLabel>
			<TextField
				fullWidth
				id='notes'
				multiline
				rows={4}
				{...getFieldProps('notes')}
				disabled={loading}
				error={getError('notes')}
				helperText={getErrorMessage('notes')}
			/>
			<FormHelperText>{NOTES_HELP_TEXT}</FormHelperText>
		</>
	);
};

export default NotesField;
